import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PRMAssistanceList from './prm-assistance-list';
import PRMAssistanceForms from './prm-assistance-forms';
import { paths } from '../../../routes';

const PRMAssistance = () => (
  <Switch>
    <Route path={paths.prmAssistanceNew.path}>
      <PRMAssistanceForms />
    </Route>
    <Route path={paths.prmAssistanceDetails.path}>
      <PRMAssistanceForms />
    </Route>
    <Route path={paths.prmAssistance.path}>
      <PRMAssistanceList />
    </Route>
  </Switch>
);

export default PRMAssistance;
